import MuiDialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import React from 'react';

import { CancelButton, CloseButton } from '../CommonButtons';

const Dialog = ({ title, action, open, onClose, children, maxWidth, form, ...props }) => {
  return (
    <MuiDialog open={open} maxWidth={maxWidth || 'sm'} fullWidth={true} onClose={onClose} {...props}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>{children}</DialogContent>
      {!form && (
        <DialogActions>
          {action ? <CancelButton onClick={onClose} /> : <CloseButton onClick={onClose} />}
          {action}
        </DialogActions>
      )}
    </MuiDialog>
  );
};

export default Dialog;
